var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondarymoderator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2602",
    "data-name": "Group 2602",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.241,
    height: 10.469,
    viewBox: "0 0 15.241 10.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M128.171,13.38a1.64,1.64,0,0,1-.36-.7,1.448,1.448,0,0,1,2.8-.744,1.1,1.1,0,0,0,.068.236v.41a3.51,3.51,0,0,1-.147.436,1.465,1.465,0,0,1-.879.753l-.114.037a.415.415,0,0,0-.092.007,1.431,1.431,0,0,1-.579-.025A1.544,1.544,0,0,1,128.171,13.38Z",
    transform: "translate(-115.436 -9.812)",
    fill: "#c5c9d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M84.05,26.709a1.544,1.544,0,0,0,.7.407,1.431,1.431,0,0,0,.579.025.424.424,0,0,0,.092-.007c-.067.508-.146,1.015-.257,1.516a7.955,7.955,0,0,1-.9,2.425.162.162,0,0,1-.024.028H78.93v-5.06a1.441,1.441,0,0,0,1.033-.433,1.943,1.943,0,0,0,.361.868,2.245,2.245,0,0,0,1.23.906,2.328,2.328,0,0,0,2.161-.371,2.175,2.175,0,0,0,.335-.3Z",
    transform: "translate(-71.315 -23.141)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M18.311,26.4V31.45H13a6.8,6.8,0,0,1-.731-1.715,11.854,11.854,0,0,1-.289-1.234c-.063-.337-.1-.675-.153-1.017a.736.736,0,0,1,.1,0,1.474,1.474,0,0,0,.836-.121,2.124,2.124,0,0,0,.435-.3,2.278,2.278,0,0,0,1.061.675,2.33,2.33,0,0,0,2.328-.533,2.364,2.364,0,0,0,.7-1.2.121.121,0,0,1,.078.042,1.447,1.447,0,0,0,.935.349Z",
    transform: "translate(-10.69 -23.494)",
    fill: "#c5c9d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M23.893,83h5.3v2.316a.156.156,0,0,0,.028.114c-.026.045-.063.032-.1.032H24.394c-.306,0-.5-.264-.5-.675C23.887,84.184,23.891,83.59,23.893,83Z",
    transform: "translate(-21.585 -74.994)",
    fill: "#abb1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M78.907,85.519c-.032-.028-.028-.071-.028-.114V83.09h5.31v1.844c0,.338-.181.579-.43.587-.343.006-.688,0-1.031,0H79.018A.608.608,0,0,1,78.907,85.519Z",
    transform: "translate(-71.269 -75.075)",
    fill: "#c5c9d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M2.518,14.067a2.645,2.645,0,0,1-.446.31,1.474,1.474,0,0,1-.836.121.736.736,0,0,0-.1,0,2.01,2.01,0,0,1-.565-.271,1.453,1.453,0,0,1-.517-1.517,1.4,1.4,0,0,1,1.169-1.07,1.431,1.431,0,0,1,1.64,1.09,1.414,1.414,0,0,1-.289,1.264C2.557,14.018,2.54,14.044,2.518,14.067Z",
    transform: "translate(-0.011 -10.499)",
    fill: "#abb1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M80.029,2.514A1.441,1.441,0,0,1,79,2.947V.047A1.4,1.4,0,0,1,80.212.7a1.434,1.434,0,0,1-.063,1.675C80.112,2.426,80.053,2.455,80.029,2.514Z",
    transform: "translate(-71.379 -0.045)",
    fill: "#c5c9d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M65.35.026V2.92a1.447,1.447,0,0,1-.935-.349c-.023-.019-.043-.044-.078-.042a1.116,1.116,0,0,0-.151-.2,1.412,1.412,0,0,1-.28-.965A1.447,1.447,0,0,1,64.854.111a1.061,1.061,0,0,1,.5-.085Z",
    transform: "translate(-57.737 -0.023)",
    fill: "#abb1c7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondarymoderator);
export default __webpack_public_path__ + "static/media/secondarymoderator.41f9bc0343b2943e5353e2e51ef2a403.svg";
export { ForwardRef as ReactComponent };